import React from "react";
import IbssDrawer from "../../../../Components/Drawer/IbssDrawer";
import
{
  Box,
  Button,
  Divider,
  LinearProgress,
  Paper,
  Typography,
  styled,
} from "@mui/material";
import IbssIconButton from "../../../../Components/Buttons/IconButton/IbssIconButton";
import CloseIcon from "../../../../Components/Icons/CloseIcon";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import IbssTextField from "../../../../Components/Inputs/TextField/IbssTextField";
import FileUploadIcon from "../../../../Components/Icons/FileUploadIcon";
import IbssButton from "../../../../Components/Buttons/Button/IbssButton";
import UserPicker, * as UserPickerModule from "../../../../Components/Inputs/UserPicker/UserPicker";
import IbssCheckBox from "../../../../Components/Inputs/CheckBox/IbssCheckBox";
import IbssAvatar from "../../../../Components/Miscellaneous/Avatar/IbssAvatar";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IbssHorizontalTabs, { TabsParameters } from "../../../../Components/Layout/Tabs/IbssTabs";
import { BookingParty } from "./DataModels";
import { appContext } from "../../../../AppContext";
import Spinner from "../../../../Components/Navigation/LoadingSpinner/Spinner";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";


const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

class ManageAttendees extends IbssComponent<IProps, IState>
{
  
  private get labels() { return appContext().labels; }

  constructor(props: IProps)
  {
    super(props);
    this.state = {
      value: 0,
      searchQuery: '',
      manualAttendeesOpen: false,
      attendeeList: [],
      hostName: '',
      hostEmail: '',
      internalAttendee: [],
      addVisitor: false,
      selectedUser: null,
      visitor: {
        email: "",
        fullName: "",
        company: "",
      },
      visitorList: [],
      selectedAttendees: [],
      tabIndex: 0,
      internalRemoveAttendee: [],
      waitListRemoveAttendee: [],
      isFileUploaded: false,
      disableSaveButton: false,
    };
  }

  public componentDidUpdate(prevProps: IProps): void
  {
    if (prevProps.attendees !== this.props.attendees) 
    {
      this.setState({attendeeList: this.props.attendees });
    }

    if (prevProps.open !== this.props.open && this.props.open) 
    {
      this.setState({ 
        tabIndex: 0,
        internalAttendee: [],
        visitorList: [],
        manualAttendeesOpen: false,
      });
      this.props.getBookingPartiesDetails();
    }
  }

  private handleManulAttendeeUpload = () =>
  {
    this.setState({ manualAttendeesOpen: true })
  }

  private handleSearchChange(event: React.ChangeEvent<HTMLInputElement>): void  
  {
    this.setState({ searchQuery: event.target.value });
  }

  private handleRemoveAttendee(recordId: string, isWaiting: boolean): void
  {
    if(isWaiting)
    {
      const removedWaitingAttendee = this.state.attendeeList.find((attendee: BookingParty) => attendee.Record_Id === recordId);
      if (removedWaitingAttendee) 
      {
        const updatedWaitList = [...this.state.waitListRemoveAttendee, removedWaitingAttendee];
        this.setState({
          waitListRemoveAttendee: updatedWaitList,
          attendeeList: this.state.attendeeList.filter(
            (attendee: BookingParty) => attendee.Record_Id !== recordId
          ),
        });
      }
    }
    else
    {
      const removedAttendee = this.state.attendeeList.find((attendee: BookingParty) => attendee.Record_Id === recordId);
      if (removedAttendee) 
      {
        this.setState({
          internalRemoveAttendee: [...this.state.internalRemoveAttendee, removedAttendee],
          attendeeList: this.state.attendeeList.filter(
            (attendee: BookingParty) => attendee.Record_Id !== recordId
          ),
        });
      }
      
    }
  }
  
  private handleRemoveInternalAttendee(email: string): void
  {
    const filteredData = this.state.internalAttendee.filter((attendee: IInternalAttendee) => attendee.email !== email);
    this.setState({
      internalAttendee: filteredData
    });
  }

  private handleRemoveVisitorAttendee(email: string): void
  {
    const filteredData = this.state.visitorList.filter((attendee: Visitor) => attendee.email !== email);
    this.setState({
      visitorList: filteredData
    });
  }

  private saveInternalAttendee(): void
  {
    const { selectedUser } = this.state;
    
    if (selectedUser) 
    {
      this.setState({
        internalAttendee: [...this.state.internalAttendee, selectedUser],
        selectedUser: null,
        hostName: '',
      });
    }
  }

  private async updateStatusToCompletedBooked(): Promise<void>
  {
      try 
      {           
        await appContext().ibssApiClientV2.v2.byNodeid.ticketedevents.byEventid.patch({
            nodeId: this.props.nodeId,
            eventid: this.props.eventId,
            body: 
            {
                Event_Status: "Completed_Booked"
            }
        }) 
      } 
      catch (error) 
      {    
      }
  }

  private async saveBookingParties(attendees: Visitor[] | IInternalAttendee[], participantType: number): Promise<void> 
  {
    const attendeeList: IBookingParty[] = [];
    const attendeeLength = this.props.attendees.filter(
      (item) => item.IsParticipant_On_WaitingList === 0
    ).length;
    const remainingCapacity = this.props.eventCapacity - attendeeLength;
  
    attendees.forEach((attendee, index: number) => {
      // Check if attendee can be added
      if (index < remainingCapacity || this.props.allowWaitingList) {
        attendeeList.push({
          Booking_Participant_Email: attendee.email,
          Booking_Participant_Name:
            participantType === 1
              ? `${(attendee as IInternalAttendee).firstName} ${(attendee as IInternalAttendee).lastName}`
              : (attendee as Visitor).fullName,
          Booking_Participant_Organisation: attendee.company,
          IsParticipant_On_WaitingList: index < remainingCapacity ? 0 : 1,
          Booking_Participant_Type: participantType,
          Ticketed_Event_Id: this.props.eventId,
        });
      }
    });
  
    try 
    {
      await appContext().ibssApiClientV2.v2.byNodeid.bookingparties.post({
        nodeId: this.props.nodeId,
        bookingid: this.props.bookingId,
        body: attendeeList,
      });

      if(remainingCapacity <= 0)
      {
        this.updateStatusToCompletedBooked();
      } 
      this.props.getBookingPartiesDetails();
      this.props.onClose();
    } 
    catch (error) 
    {
    }
  }
  
  
  

  private handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void 
  {
    const { name, value } = event.target;
    this.setState({
      visitor: {
        ...this.state.visitor,
        [name]: value,
      },
    });
  }


  private saveVisitor(): void
  {
    const { visitor } = this.state;
    this.setState({
      visitorList: [...this.state.visitorList, visitor],
      visitor: { email: "", fullName: "", company: "" },
    });
  }

  private async selectedUserChanged(user: UserPickerModule.IUser | null): Promise<void>
  {
    if (user) 
    {
      this.setState({
        selectedUser: {
          email: user.email || "",
          firstName: user.firstName || "",
          lastName: user.lastName || "",
          company: user.company || "",
        },
      });
    }
  }

  private statusChanged(e: React.ChangeEvent<HTMLInputElement>): void 
  {
    this.setState({
      addVisitor: e.target.checked
    });
  };

  private handleSelectAttendee(attendee: BookingParty): void 
  {
    const isSelected = this.state.selectedAttendees.some(
      (selected: BookingParty) => selected.Record_Id === attendee.Record_Id
    );
  
    if (isSelected) 
    {
      // Remove if already selected
      this.setState({
        selectedAttendees: this.state.selectedAttendees.filter(
          (selected: BookingParty) => selected.Record_Id !== attendee.Record_Id
        ),
      });
    } 
    else 
    {
      // Add if not selected
      this.setState({
        selectedAttendees: [...this.state.selectedAttendees, attendee],
      });
    }
  }
  

  private async saveAttendees(selectedTabIndex: number): Promise<void> 
  {
    this.setState({ disableSaveButton: true });

    try 
    {
      if (this.state.selectedAttendees.length > 0 && selectedTabIndex === 1) 
        {
          const promises = this.state.selectedAttendees.map((attendee: BookingParty) =>
            appContext().ibssApiClientV2.v2.byNodeid.bookingparties.byRecordid.patch({
              nodeId: this.props.nodeId,
              recordid: attendee.Record_Id,
              body: {
                IsParticipant_On_WaitingList: 0,
                Is_Ticketed_Event: true,
              },
            })
          );
          
        await Promise.all(promises);
      } else 
      {
        const attendeeList = selectedTabIndex === 0 ? this.state.internalRemoveAttendee : this.state.waitListRemoveAttendee;

        const recordIds = attendeeList.map((attendee: BookingParty) => ({
          Record_Id: attendee.Record_Id,
        }));

        await appContext().ibssApiClientV2.v2.byNodeid.bookingparties.delete.patch({
          nodeId: this.props.nodeId,
          body: recordIds,
        });
      }

      this.props.getBookingPartiesDetails();
      this.props.onClose();
    } catch (error) 
    {
    } finally 
    {
      this.setState({ disableSaveButton: false });
    }
  }


  private async handleFileUpload(event: React.ChangeEvent<HTMLInputElement>): Promise<void> 
  {
    try 
    {
      const file = event.target.files;
      if (file) 
      {
        this.setState({ isFileUploaded: true });
        
        const formData = new FormData();
        formData.append("file", file[0]);
  
        const response = await appContext().ibssApiClientV2.v2.byNodeid.bookingparties.import.byBookingid.post({
          nodeId: this.props.nodeId,
          bookingid: this.props.bookingId,
          body: formData,
        });
  
        if (response) 
        {
          this.setState({ isFileUploaded: false });
          this.props.getBookingPartiesDetails();
          this.props.onClose();
        }
      }
    } 
    catch
    {
      this.setState({ isFileUploaded: false });
    }
  }
  
  

  public render(): JSX.Element
  {
    const { open, onClose } = this.props;
    const { attendeeList } = this.state;

    const filteredAttendees = attendeeList.filter((item) => item.IsParticipant_On_WaitingList === 0).filter((attendee: BookingParty) =>
      attendee.Booking_Participant_Name.toLowerCase().includes(this.state.searchQuery.toLowerCase())
    );

    const filteredWaitingList = attendeeList.filter((item) => item.IsParticipant_On_WaitingList === 1).filter((attendee: BookingParty) =>
      attendee.Booking_Participant_Name.toLowerCase().includes(this.state.searchQuery.toLowerCase())
    );

    const attendeesTabs: TabsParameters[] = [
      {
        label: this.labels.funcAttending_S,
        components: (
          <Box sx={{ bgcolor: "var(--ui-background)" }}>
            <Box  sx={{height:'calc(100vh - 419px)', overflowY:'auto',p:3}}>
              <Button
                component="label"
                role={undefined}
                variant="outlined"
                color="secondary"
                sx={{
                  border: "1px dashed var(--ui-text-alternate)",
                  px: 1.5,
                  py: 2,
                  bgcolor: "transparent",
                }}
                tabIndex={-1}
                fullWidth
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  width="100%"
                >
                  {this.labels.funcBatchUploadAttendees_L}
                  <Box> 
                  {this.state.isFileUploaded ? 
                    <Spinner /> 
                  :
                  <IbssSvgIcon>
                    <FileUploadIcon />
                  </IbssSvgIcon>
                  }
                  </Box>
                </Box>
                <VisuallyHiddenInput
                  type="file"
                  onChange={(event) =>  this.handleFileUpload(event)}
                />
              </Button>
              <IbssButton
                variant="contained"
                color="secondary"
                fullWidth
                sx={{ mt: 2, py: 1 }}
                onClick={() => this.handleManulAttendeeUpload()}
              >
                {this.labels.funcManualAttendeeUpload_L}
              </IbssButton>
              <Box width="100%" my={2}>
                <Divider />
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" className="ibss-text-light">
                  {this.labels.funcInternalAttendees_L}
                </Typography>
              </Box>
              <Box>
                {filteredAttendees.map((attendee: BookingParty, index: number) => (
                  <Paper sx={{ my: 2, borderRadius: "0.5rem" }} elevation={0}>
                    <Box
                      p={1}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box display="flex" gap={2} alignItems="center">
                        <IbssAvatar fullName={attendee.Booking_Participant_Name} />
                        <Typography
                          variant="body2"
                          className="ibss-text-light"
                        >
                          {attendee.Booking_Participant_Name}
                        </Typography>
                      </Box>
                      <IbssIconButton onClick={() => this.handleRemoveAttendee(attendee.Record_Id, false)}>
                        <IbssSvgIcon sx={{fontSize:'1rem'}}>
                          <CloseIcon />
                        </IbssSvgIcon>
                      </IbssIconButton>
                    </Box>
                  </Paper>
                ))}
              </Box>
            </Box>
            </Box>
        )
      },
      {
        label: this.labels.funcWaitlists_S,
        components: (
          <Box sx={{ bgcolor: "var(--ui-background)" }}>
            <Box sx={{height:'calc(100vh - 419px)', overflowY:'auto',p:3}}>
                <Box>
                  {filteredWaitingList.map((attendee: BookingParty, index: number) => (
                    <Paper sx={{ my: 2, borderRadius: "0.5rem" }} elevation={0}>
                      <Box
                        p={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box display="flex" gap={2} alignItems="center">
                          <IbssAvatar fullName={attendee.Booking_Participant_Name} />
                          <Typography
                            variant="body2"
                            className="ibss-text-light"
                          >
                            {attendee.Booking_Participant_Name}
                          </Typography>
                        </Box>
                        <Box gap={2} display="flex" alignItems={'center'}>
                        <CheckCircleIcon
                          sx={{ cursor: 'pointer' }}
                          color={
                            this.state.selectedAttendees.some(
                              (selected: BookingParty) => selected.Record_Id === attendee.Record_Id
                            )
                              ? 'success'
                              : 'disabled'
                          }
                          onClick={() => this.handleSelectAttendee(attendee)}
                        />
                        <IbssIconButton onClick={() => this.handleRemoveAttendee(attendee.Record_Id, true)}>
                          <IbssSvgIcon sx={{fontSize:'1rem'}}>
                            <CloseIcon />
                          </IbssSvgIcon>
                        </IbssIconButton>
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                </Box> 
            </Box>
            </Box>
        )
      }
    ];

    const internalAttendeesTabs: TabsParameters[] = [
      {
        label: this.labels.funcInternal_S,
        components:(
          <Box sx={{ bgcolor: "var(--ui-background)", height: 'calc(100vh - 442px)', display: 'flex', flexDirection: 'column' }}>
          <Box width="100%" my={2}>
            <Divider />
          </Box>
          <Box display="flex" justifyContent="space-between" px={3}>
            <Typography variant="body2" className="ibss-text-light">
              {this.labels.HubLabelAttendees}
            </Typography>
            <IbssButton onClick={() => this.setState({ manualAttendeesOpen: false })} className="ibss-text-light">
              {this.labels.funcJumpToAttendees_L}
            </IbssButton>
          </Box>
          <Box
            sx={{
              p: 3,
              flexGrow: 1,
              overflowY: 'auto',
            }}
          >
            {this.state.internalAttendee.length > 0 && this.state.internalAttendee.map((attendee: IInternalAttendee, index: number) => (
              <Paper key={index} sx={{ my: 2, borderRadius: "0.5rem" }} elevation={0}>
                <Box
                  p={1}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box display="flex" gap={2} alignItems="center">
                    <IbssAvatar fullName={attendee.email} />
                    <Typography
                      variant="body2"
                      className="ibss-text-light"
                    >
                      {attendee.email}
                    </Typography>
                  </Box>
                  <IbssIconButton onClick={() => this.handleRemoveInternalAttendee(attendee.email)}>
                    <IbssSvgIcon>
                      <CloseIcon />
                    </IbssSvgIcon>
                  </IbssIconButton>
                </Box>
              </Paper>
            ))}
        </Box>
          <Paper
            sx={{
              py: 3,
              px: 4,
              boxSizing: "border-box",
              position: "sticky",
              bottom: 0,
              width: "100%",
              zIndex: 10,
            }}
          >
            <IbssButton size="large" variant="contained" fullWidth onClick={() => this.saveBookingParties(this.state.internalAttendee,1)}>
              {this.labels.HubButtonSave}
            </IbssButton>
          </Paper>
      </Box>
        )
      },
      {
        disabled: this.props.invitePermission == 'Internal',
        label: this.labels.funcVisitor_S,
        components:(
          <Box sx={{ bgcolor: "var(--ui-background)", height: 'calc(100vh - 442px)', display: 'flex', flexDirection: 'column' }}>
          {/* Top Section */}
          <Box width="100%" my={2}>
            <Divider />
          </Box>

          <Box display="flex" justifyContent="space-between" px={3}>
            <Typography variant="body2" className="ibss-text-light">
              {this.labels.HubLabelAttendees}
            </Typography>
            <IbssButton onClick={() => this.setState({ manualAttendeesOpen: false })} className="ibss-text-light">
              {this.labels.funcJumpToAttendees_L}
            </IbssButton>
          </Box>
        <Box sx={{ p: 3, flexGrow: 1, overflowY: 'auto', }}>
          {this.state.visitorList.length > 0 && this.state.visitorList.map((attendee: Visitor, index: number) => (
            <Paper key={index} sx={{ my: 2, borderRadius: "0.5rem" }} elevation={0}>
              <Box
                p={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" gap={2} alignItems="center">
                  <IbssAvatar fullName={attendee.email} />
                  <Typography
                    variant="body2"
                    className="ibss-text-light"
                  >
                    {attendee.email}
                  </Typography>
                </Box>
                <IbssIconButton onClick={() => this.handleRemoveVisitorAttendee(attendee.email)}>
                  <IbssSvgIcon>
                    <CloseIcon />
                  </IbssSvgIcon>
                </IbssIconButton>
              </Box>
            </Paper>
          ))}
          </Box>
          <Paper
            sx={{
              py: 3,
              px: 4,
              boxSizing: "border-box",
              position: "sticky",
              bottom: 0,
              width: "100%",
              backgroundColor: "background.paper",
              zIndex: 10,
            }}
          >
            <IbssButton size="large" variant="contained" fullWidth onClick={() => this.saveBookingParties(this.state.visitorList,2)}>
              {this.labels.HubButtonSave}
            </IbssButton>
          </Paper>
        </Box>
        )
      }
    ] 
  
    const availableTabs =  this.props.allowWaitingList ? attendeesTabs : attendeesTabs.filter((tab) => tab.label !== this.labels.funcWaitlists_S);
    
    return (
      <>
        <IbssDrawer
          open={open}
          onClose={onClose}
          anchor="right"
          className="flex-search-filter-criteria"
          sx={{ backgroundColor: "var(--ui-background-alternate)" }}
        >
          <Box p={4}>
            <Box display="flex" justifyContent="end">
              <IbssIconButton onClick={onClose}>
                <IbssSvgIcon sx={{fontSize:'1.3rem'}}>
                  <CloseIcon />
                </IbssSvgIcon>
              </IbssIconButton>
            </Box>
            <Typography variant="h6">{this.labels.funcManageEventVisitors_L}</Typography>
            <Typography variant="body2" className="ui-text-light">
              {this.labels.funcAddPeopleAndManage_L}
            </Typography>
            <Box my={2} display="flex" justifyContent="space-between" gap={2}>
              <Box width="100%">
                <LinearProgress
                  variant="determinate"
                  value={Math.min((this.props.bookingPartyCount / this.props.eventCapacity) * 100, 100)}
                  sx={{ mt: 1 }}
                />
              </Box>
              <Box>
                <Typography variant="body2" noWrap> {this.props.bookingPartyCount}/ {this.props.eventCapacity}</Typography>
              </Box>
            </Box>
            {!this.state.manualAttendeesOpen ?
              <IbssTextField
                variant="outlined"
                placeholder={this.labels.funcSearchAttendees_S}
                fullWidth
                value={this.state.searchQuery}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleSearchChange(e)}
              />
              :
              <>
              {this.state.tabIndex === 0 &&
                <Box display={"flex"} justifyContent={"space-between"} gap={2}>
                  <Typography variant="body2">{this.labels.HubButtonVisitorAccess}</Typography>
                  <IbssCheckBox
                    disabled={this.props.invitePermission == 'Internal'}
                    checked={this.state.addVisitor}
                    onClicked={(e: React.ChangeEvent<HTMLInputElement>) => this.statusChanged(e)}
                  />
                </Box>
                }
                {this.state.addVisitor || this.state.tabIndex === 1 ?
                  <>
                    <IbssTextField
                      sx={{ mt: 2 }}
                      fullWidth
                      placeholder={this.labels.HubLabelEmailAddress}
                      name="email"
                      value={this.state.visitor.email}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleInputChange(e)}
                    />
                    <IbssTextField
                      sx={{ mt: 2 }}
                      fullWidth
                      placeholder={this.labels.HubLabelFullName}
                      name="fullName"
                      value={this.state.visitor.fullName}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleInputChange(e)}
                    />
                    <IbssTextField
                      sx={{ mt: 2 }}
                      fullWidth
                      placeholder={this.labels.HubLabelCompany}
                      name="company"
                      value={this.state.visitor.company}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleInputChange(e)}
                    />
                    <IbssButton sx={{ mt: 2 }} size="large" variant="contained" fullWidth onClick={() => this.saveVisitor()}>
                      {this.labels.HubButtonAdd}
                    </IbssButton>
                  </>
                  :
                  <>
                    <UserPicker
                      searchText={this.state.hostName}
                      placeholder="add name here"
                      onChange={async text => this.setState({ hostName: text })}
                      onUserChange={user => this.selectedUserChanged(user)}
                    />
                    <IbssButton sx={{ mt: 2 }} size="large" variant="contained" fullWidth onClick={() => this.saveInternalAttendee()}>
                      {this.labels.HubLabelAddButton}
                    </IbssButton>
                  </>
                }
              </>
            }
          </Box>
          {!this.state.manualAttendeesOpen ?
            <>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <IbssHorizontalTabs
                    tabs={availableTabs}
                    className="someone-else-delegated-tab"
                    orientation="horizontal"
                    boxwidth='100%'
                    tabChanged={(tabValue) => this.setState({ tabIndex: tabValue })}
                  />
                </Box>
              </Box>
              <Paper
                sx={{
                  py: 3,
                  px: 4,
                  boxSizing: "border-box",
                  position: "sticky",
                  Top: "100%",
                  width: "100%",
                }}
              >
                <IbssButton size="large" variant="contained" fullWidth disabled={this.state.disableSaveButton} onClick={() => this.saveAttendees(this.state.tabIndex)}>
                 {this.state.tabIndex === 0 ? this.labels.HubButtonSave : this.labels.funcSaveWaitList_S}
                </IbssButton>
              </Paper>
            </>
            :
            <Box sx={{ width: "100%" }}>
              <IbssHorizontalTabs 
                  tabs={internalAttendeesTabs}
                  tabChanged={(tabValue) => this.setState({ tabIndex: tabValue })}
                  className="someone-else-delegated-tab"
                  orientation="horizontal"
                  boxwidth='100%'
              />
            </Box>}
        </IbssDrawer>
      </>
    );
  }
}

export default ManageAttendees;

interface IProps
{
  allowWaitingList: boolean;
  open: boolean;
  onClose: () => void;
  nodeId: number;
  bookingId: string;
  eventId: string;
  attendees: BookingParty[];
  getBookingPartiesDetails: () => void;
  eventCapacity: number;
  bookingPartyCount: number;
  invitePermission: string;
}

interface Visitor
{
  email: string;
  fullName: string;
  company: string;
}

interface ISelectedUser
{
  email: string,
  firstName: string,
  lastName: string,
  company: string
}

interface IInternalAttendee
{
  email: string;
  firstName: string;
  lastName: string;
  company: string;
}

interface IState 
{
  value: number;
  searchQuery: string;
  manualAttendeesOpen: boolean;
  attendeeList: BookingParty[];
  hostName: string,
  hostEmail: string,
  internalAttendee: IInternalAttendee[];
  addVisitor: boolean;
  selectedUser: ISelectedUser | null;
  visitor: Visitor;
  visitorList: Visitor[];
  selectedAttendees: BookingParty[];
  tabIndex: number;
  internalRemoveAttendee: BookingParty[];
  waitListRemoveAttendee: BookingParty[];
  isFileUploaded: boolean;
  disableSaveButton: boolean;
}


export interface IBookingParty
{
    Booking_Participant_Email: string;
    Booking_Participant_Name: string;
    Booking_Participant_Organisation: string;
    Booking_Participant_Type: number;
    IsParticipant_On_WaitingList: number;
    Ticketed_Event_Id: string;
}